module.exports = __webpack_public_path__ + "static/level_2.563dd8dd.png";